export default __webpack_public_path__ + "static/image5-93f2bb289ec7abf77dbee77bd19ee7a9.gif";